import React from "react";

const AccountsIcon = ({ size = 12, color = "", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 13"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.35345 1.64648C6.30705 1.60001 6.25195 1.56314 6.19129 1.53798C6.13064 1.51283 6.06561 1.49988 5.99995 1.49988C5.93428 1.49988 5.86926 1.51283 5.8086 1.53798C5.74794 1.56314 5.69284 1.60001 5.64645 1.64648L1.14645 6.14648C1.07654 6.2164 1.02894 6.30549 1.00966 6.40246C0.990371 6.49944 1.00027 6.59996 1.03811 6.69131C1.07594 6.78266 1.14001 6.86074 1.22222 6.91568C1.30442 6.97062 1.40107 6.99996 1.49995 6.99998H1.99995V10.5C1.99995 11.0515 2.44845 11.5 2.99995 11.5H8.99995C9.55145 11.5 9.99995 11.0515 9.99995 10.5V6.99998H10.4999C10.5989 7.0002 10.6957 6.971 10.7781 6.9161C10.8605 6.8612 10.9247 6.78306 10.9625 6.69162C11.0004 6.60017 11.0103 6.49953 10.9908 6.40247C10.9714 6.30541 10.9236 6.21631 10.8534 6.14648L6.35345 1.64648ZM9.00045 10.5H2.99995V5.70698L5.99995 2.70698L8.99995 5.70698V7.99998L9.00045 10.5Z"
      stroke="currentColor"
      strokeWidth="0.05"
      fill="currentColor"
    />
    <path
      d="M6.49994 5.5H5.49994V7H3.99994V8H5.49994V9.5H6.49994V8H7.99994V7H6.49994V5.5Z"
      stroke="currentColor"
      strokeWidth="0.05"
      fill="currentColor"
    />
  </svg>
);

export default AccountsIcon;
